import React from 'react'
import { WizardContext } from 'react-albus'

import * as S from './styles'
import content from './content'

import { useSignup } from '../../store'

export type NotesProps = {
  wizard: WizardContext
}

export const Notes = ({ wizard }: NotesProps) => {
  const { onSync } = useSignup()

  const handleSubmit = async () => {
    await onSync()
    wizard.next()
  }

  return (
    <S.Container>
      <S.Notes>
        {content.map(({ title, content }, index) => (
          <S.Note.Item key={index}>
            <S.Note.Title>{title}</S.Note.Title>
            <S.Note.Content>{content}</S.Note.Content>
          </S.Note.Item>
        ))}
      </S.Notes>

      <S.Actions>
        <S.Action onClick={wizard.previous} icon="ArrowLeft" kind="smooth">
          Voltar
        </S.Action>

        <S.Action onClick={handleSubmit} icon="Check">
          Concluir cadastro
        </S.Action>
      </S.Actions>
    </S.Container>
  )
}
